import React from 'react';
import PropTypes from 'prop-types';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ukLocale from "date-fns/locale/uk";


function SimpleDatePicker({
  selectedDate,
  handleDateChange,
  label,
  helperText,
  inputProps,
  withCalendarIcon,
  ...props
}) {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ukLocale}>
      <KeyboardDatePicker
        minDateMessage=""
        maxDateMessage=""
        disableToolbar
        autoOk
        variant="inline"
        inputVariant="outlined"
        format="dd/MM/yyyy"
        label={label}
        value={selectedDate}
        onChange={(date) => {
          handleDateChange(date);
        }}
        {...helperText && { helperText }}
        {...inputProps && { inputProps }}
        {...props}
      />
    </MuiPickersUtilsProvider>
  );
}

SimpleDatePicker.defaultProps = {
  selectedDate: '',
  withCalendarIcon: true,
  inputProps: {},
};

SimpleDatePicker.propTypes = {
  withCalendarIcon: PropTypes.bool,
  handleDateChange: PropTypes.func.isRequired,
  inputProps: PropTypes.shape({
    'data-test': PropTypes.string,
  }),
  selectedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  label: PropTypes.string.isRequired,
};

export default SimpleDatePicker;
